import { LanguageContext } from '@/context/LanguageContext';
import { BuildPath, flagBuilder } from  '@/helpers/Paths';
import React, { useContext, useEffect } from 'react';
import SimpleBar from 'simplebar-react';

const QuickTranslateQ1 = () => {

    const languageContext = useContext(LanguageContext);

    function toggle(id:number){

        const languages = languageContext.store.languageSelected;

        const exists = languages.find(x => x.languageId === id);

        // Remove
        if (exists){

            languageContext.setStore({
                ...languageContext.store, 
                languageSelected:languages.filter(x => x.languageId !== id)
            })

        }
        // Add
        else{

            const add = languageContext.store.languageAvailable.find(x => x.languageId === id);

            languageContext.setStore({
                ...languageContext.store, 
                languageSelected:[...languages, add]
            })
        }
    }

    function preSelected(id:number) {
        const exists = languageContext.store.languageSelected.find(x => x.languageId === id);

        if (exists){
            return true
        }

        return false
    }

    function getFlagStyle (flagPath: string){
        return {
            height: '53px',
            border: '0.5px solid #dadada',
            borderRadius: '4px',
            backgroundImage: `url(${flagPath}), url(${BuildPath()}/images/translations/Flags/flagNotFound.svg)`, 
            backgroundRepeat: 'no-repeat, no-repeat', 
            backgroundSize: '92px 54px, 92px 54px', 
            backgroundPosition: 'center, center'
        }
    }

    return (
        <div className='available-languages'>

            <p>Please select one or more language(s) you wish to take an action on. If the language(s) you're looking for doesn't appear, please make sure it is enabled within the Org Settings.</p>
            
            <SimpleBar className="scroll-results" style={{ maxHeight: 299 }} forceVisible={true} autoHide={false}>
                <ul>
                    {languageContext.store.languageAvailable.filter(x => x.settingsSaved === true).map(item => {
                        return (
                            <li key={item.languageId} onClick={() => toggle(item.languageId)}>
                                <div title="Flag" style={getFlagStyle(flagBuilder(item.flagRegionCode))}>&nbsp;</div>
                                <div>
                                    <input checked={preSelected(item.languageId)} type='checkbox' onChange={() => {}} />
                                    <span>{item.name}</span>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </SimpleBar>

        </div>
    );
};

export default QuickTranslateQ1;